import splitClassTokens from './split-class-tokens';
import parsePrefixedClassToken from './parse-prefixed-class-token';

const removeClassTokens = (classString, { prefix = null, matchesToken }) =>
  splitClassTokens(classString)
    .filter((token) => {
      const parsed = parsePrefixedClassToken(token);

      return parsed.prefix !== prefix || !matchesToken(parsed.token);
    })
    .join(' ');

export default removeClassTokens;
